import { useState, type FormEvent } from 'react';

import styles from './Footer.module.css';
import { LandingImage } from './LandingImage';
import { stashLandingValues } from './landingStorage';

type FooterProps = {
	onCta: () => void;
};

export const Footer = ({ onCta }: FooterProps) => {
	const [website, setWebsite] = useState('');
	const [handle, setHandle] = useState('');

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault();
		stashLandingValues({ website, handle });
		onCta();
	};

	return (
		<footer className={styles.footer}>
			<div className={styles.hero}>
				<LandingImage
					src="/landing/footer-hero-bg.jpg"
					alt=""
					className={styles.heroImage}
				/>
				<div className={styles.inner}>
					<div className={styles.stack}>
						<h2 className={styles.heading}>
							Your new teammate is two minutes away.
						</h2>
						<form className={styles.formCard} onSubmit={handleSubmit}>
							<div className={styles.formHeader}>
								<h3 className={styles.formHeading}>
									We&rsquo;ll set up your first agent before you&rsquo;ve
									finished your coffee.
								</h3>
								<p className={styles.formSub}>
									No credit card, completely free. See what Project Bridgeway
									can do before you commit.
								</p>
							</div>
							<div className={styles.formRow}>
								<label className={styles.field}>
									<span className="sr-only">Brand website</span>
									<input
										type="url"
										value={website}
										onChange={(e) => setWebsite(e.target.value)}
										placeholder="Brand website"
										className={styles.input}
										autoComplete="url"
									/>
								</label>
								<label className={`${styles.field} ${styles.fieldWithPrefix}`}>
									<span className="sr-only">Brand Instagram handle</span>
									<span className={styles.fieldPrefix} aria-hidden="true">
										@
									</span>
									<input
										type="text"
										value={handle}
										onChange={(e) => setHandle(e.target.value)}
										placeholder="Brand Instagram handle"
										className={`${styles.input} ${styles.inputWithPrefix}`}
										autoComplete="username"
									/>
								</label>
								<button type="submit" className={styles.submit}>
									Submit
									<span aria-hidden="true" className={styles.submitArrow}>
										→
									</span>
								</button>
							</div>
						</form>
					</div>
					<div className={styles.adobeLockup} aria-label="Adobe">
						<LandingImage
							src="/landing/adobe-mark.svg"
							alt=""
							className={styles.adobeMark}
						/>
						<LandingImage
							src="/landing/adobe-wordmark.svg"
							alt=""
							className={styles.adobeWordmark}
						/>
					</div>
				</div>
			</div>
			<div className={styles.legalBar}>
				<p className={styles.legalText}>
					Copyright &copy; 2026 Adobe. All Rights Reserved.
					<span className={styles.legalDivider}>&bull;</span>
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="http://www.adobe.com/go/privacy_policy"
						className={styles.legalLink}
					>
						Privacy Policy
					</a>
					<span className={styles.legalDivider}>&bull;</span>
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="http://www.adobe.com/go/terms"
						className={styles.legalLink}
					>
						Terms of Use
					</a>
				</p>
			</div>
		</footer>
	);
};
